import React from 'react';
import SbEditable from 'storyblok-react';
import TextCard from '~/components/Dynamic/TextCard';
import Image from '~/components/Dynamic/Image';

export default function TwoColumnIconCards({ blok }) {
  return (
    <section className="relative mb-20 md:mb-28">
      <div className="container">
        <div className="grid gap-6 mx-auto md:grid-cols-2">
          {blok.cards.map((card, i) => (
            <SbEditable content={card} key={card._uid}>
              <div className="flex flex-col items-start flex-auto p-8 py-12 text-black lg:p-10 xl:p-12 xl:py-16 bg-beige">
                <div className="max-w-[22rem]">
                  <div className="flex flex-auto w-full mb-8 h-28 max-h-28">
                    <Image
                      blok={card.icon}
                      className="flex-auto object-contain object-left"
                      imageClassName="h-full "
                    />
                  </div>
                  <TextCard
                    className="mb-16"
                    blok={{
                      ...card,
                      headingClass: card.headingClass + ' text-38px',
                      icon: '',
                    }}
                  />
                </div>
              </div>
            </SbEditable>
          ))}
        </div>
      </div>
    </section>
  );
}
